import { Box, type ButtonProps, Icon, Button, Text } from '@chakra-ui/react'
import { useColorPalette } from './color-palette-context';
import { useColorMode } from './color-mode';

interface PromptButtonProps extends ButtonProps {
  icon: React.ReactElement,
  onPromptClick: (prompt: string) => void,
  fontFamily?: string,
  headerText?: string,
}

export const PromptButton = (props: PromptButtonProps) => {
  const { icon, children, onPromptClick, fontFamily, headerText, ...rest } = props
  const handleClick = () => {
    onPromptClick(children as string);
  };

  const {colorPalette} = useColorPalette();
  const { colorMode } = useColorMode();

  return (
    <Button
      variant={"subtle"}
      bgColor={colorPalette == 'gray' && colorMode == 'dark' ? '#262626' : ''}
      _hover={{bg: colorPalette == 'gray' && colorMode == 'dark' ? 'fg.muted/50' : ''}}
      minH={{ base: '80px', md: '200px' }}
      w="100%"
      alignItems="flex-start"
      p="3"
      textStyle="md"
      fontWeight="medium"
      whiteSpace="normal"
      textAlign="start"
      onClick={handleClick}
      fontFamily={fontFamily}
      justifyContent={'flex-start'}
      flexDirection={'column'}
      {...rest}
    >
        <Text fontSize={'lg'} fontWeight={'600'} w="100%" truncate={{ base: true, md: false }} whiteSpace={{ base: 'nowrap', md: 'normal' }}>{headerText}</Text>
      <Text w="100%" truncate={{ base: true, md: false }} whiteSpace={{ base: 'nowrap', md: 'normal' }}>{children}</Text>
      <Box pos="absolute" bottom="3" insetEnd="3" display={{ base: 'none', md: 'block' }}>
        <Icon size="lg" color="colorPalette.fg/50" aria-hidden="true">
          {icon}
        </Icon>
      </Box>
    </Button>
  )
}